/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_IntroInputs */



/**
* | output |
* | --- |
* | "Register for an event, check in, and follow the standings from your seat. Organizers run the whole event from a phone — and it keeps working when the venue h..." |
*
* @param {Landing_IntroInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const landing_intro = /** @type {((inputs?: Landing_IntroInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_IntroInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inscrivez-vous à un tournoi, pointez à l'arrivée et suivez le classement depuis votre siège. Les organisateurs gèrent tout l'événement depuis un téléphone — et tout continue de fonctionner quand la salle n'a pas de réseau.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Regístrese en un torneo, confirme su asistencia y siga la clasificación desde su asiento. Los organizadores gestionan todo el evento desde un teléfono — y todo sigue funcionando cuando la sede no tiene señal.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Inscreva-se em um torneio, faça o check-in e acompanhe a classificação do seu assento. Os organizadores conduzem o evento inteiro pelo telefone — e tudo continua funcionando quando o local está sem sinal.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Iscriviti a un torneo, fai il check-in e segui la classifica dal tuo posto. Gli organizzatori gestiscono l'intero evento dal telefono — e tutto continua a funzionare quando la sede non ha segnale.")
	return /** @type {LocalizedString} */ ("Register for an event, check in, and follow the standings from your seat. Organizers run the whole event from a phone — and it keeps working when the venue has no signal.")
});